/**
 * parser
 *
 * Created by Samuel on 2022/8/15
 */

// 快速检查是否包含特殊符号
import cx from 'clsx';
import * as _ from 'lodash-es';

import { isReactComponent } from '@core/utils/isReactComponent';

const _QUICK_CHECK = /\*\*|\[\[|]]|\{\{|}}/gm;
// convert string to array of tokens
const _TOKEN_BLOCK = /\*\*((?:.|\r?\n)+?)\*\*|\[\[((?:.|\r?\n)+?)]]/g;
const _TOKEN_VAR_FULL = /\{\{((?:.|\r?\n)+?)\}\}/g;
const _TOKEN_VAR_INNER = /\{((?:.|\r?\n)+?)\}/g;

const TYPE_NORMAL = 1;
const TYPE_HIGHLIGHT = 2;
const TYPE_CUSTOM_CLASSNAME = 3;
const TYPE_VAR = 4;

function parseText(str, innerMode = false) {
	const token = innerMode ? _TOKEN_VAR_INNER : _TOKEN_VAR_FULL;
	let lastIndex = (token.lastIndex = 0);
	const tokens = [];
	let match, index;
	// eslint-disable-next-line no-cond-assign
	while ((match = token.exec(str))) {
		index = match.index;
		if (index > lastIndex) {
			tokens.push(str.substring(lastIndex, index));
		}

		tokens.push({
			type: TYPE_VAR,
			value: match[1].trim(),
		});
		lastIndex = index + match[0].length;
	}

	if (lastIndex < str.length) {
		tokens.push(str.substring(lastIndex));
	}

	return tokens;
}
// 转换成数组形式，便于渲染
function tokenize(str) {
	let lastIndex = (_TOKEN_BLOCK.lastIndex = 0);
	const tokens = [];
	let match, index;
	// eslint-disable-next-line no-cond-assign
	while ((match = _TOKEN_BLOCK.exec(str))) {
		index = match.index;
		if (index > lastIndex) {
			tokens.push({
				type: TYPE_NORMAL,
				value: parseText(str.substring(lastIndex, index)),
			});
		}

		if (match[1]) {
			// highlight
			tokens.push({
				type: TYPE_HIGHLIGHT,
				value: parseText(match[1], false),
			});
		} else if (match[2]) {
			// style block
			let propsNameIndex = match[2].indexOf('|');

			const customProps = propsNameIndex > 0 ? match[2].substring(propsNameIndex + 1).trim() : null;
			const content = propsNameIndex > 0 ? match[2].substring(0, propsNameIndex) : match[2];
			tokens.push({
				type: TYPE_CUSTOM_CLASSNAME,
				customProps: customProps,
				value: parseText(content, true),
			});
		}

		lastIndex = index + match[0].length;
	}

	if (lastIndex < str.length) {
		tokens.push({ type: TYPE_NORMAL, value: parseText(str.substring(lastIndex)) });
	}

	return tokens;
}

const _stringParser = (raw, name) => {
	if (raw.match(_QUICK_CHECK)) {
		const _renderer = ((raw) => {
			const tokens = tokenize(raw);

			return function _$renderer(props) {
				return (
					<>
						{tokens.map((d, idx) => {
							let content = _.reduce(
								d.value,
								(res, content) => {
									if (typeof content === 'string') {
										return res + content;
									} else {
										if (content.type === TYPE_VAR) {
											// 过滤掉 undefined的情况 & console 报错
											let d = props[content.value];
											if (d == null) {
												d = '';
												// console.error(`cannot find data "${content.value}", please check it!`);
											}
											return res + `${d}`;
										}
									}
								},
								'',
							);

							if (d.type === TYPE_NORMAL) {
								return content;
							} else if (d.type === TYPE_HIGHLIGHT) {
								return (
									<span className={cx('highlight', props.highlight)} key={'d' + idx}>
										{content}
									</span>
								);
							} else {
								let customProps = props[d.customProps];
								let Component = 'span';
								// 兼容传入值是字符串的情况：如果传入的是字符串则一定是表示为className
								if (_.isString(customProps)) {
									customProps = {
										className: customProps,
									};
								} else if (customProps && _.isPlainObject(customProps)) {
									if (customProps.component && isReactComponent(customProps.component)) {
										Component = customProps.component;
									}
									customProps = _.omit(customProps, ['component']);
								}
								return (
									<Component {...customProps} key={'d' + idx}>
										{content}
									</Component>
								);
							}
						})}
					</>
				);
			};
		})(raw);
		return [_renderer, true];
	} else {
		return [raw, false];
	}
};

const _LINE = /\r?\n/g;
export const parser = (raw, name) => {
	if (!raw) {
		console.error('cannot found content::', name);
		return ['', false];
	}
	// 处理数组的情况
	if (_.isString(raw) && _LINE.test(raw)) {
		raw = raw.split(_LINE);
	}

	if (_.isArray(raw)) {
		const _renderer = ((raw) => {
			// 预处理
			const _res = _.map(raw, (line, index) => {
				const [lineRes] = _stringParser(line, `${name}.${index}`);
				if (lineRes) {
					if (isReactComponent(lineRes)) {
						return { component: lineRes };
					} else {
						return { content: lineRes, isPure: true };
					}
				}
			});
			const _len = _res.length;

			return function _renderer(props) {
				return (
					<>
						{_.reduce(
							_res,
							(res, line, index) => {
								if (line.component) {
									res.push(<line.component key={'lcp' + index} {...props} />);
								} else if (line.isPure) {
									res.push(line.content);
								}
								if (index + 1 < _len) {
									res.push(<br key={'br' + index} />);
								}
								return res;
							},
							[],
						)}
					</>
				);
			};
		})(raw);

		return [_renderer, true];
	}

	return _stringParser(raw, name);
};
